module.exports = __webpack_public_path__ + "img/EnergyIO.a423f6ef.png";